import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getParentData,
  handleBranchRequestSlice,
  resetBranchMessage,
} from "../../../store/slices/branchSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { useNavigate } from "react-router-dom";
const RequestBranch = () => {
  const dispatch = useDispatch();
  const { data, branchSuccessMessage, branchErrorMessage } = useSelector(
    (state) => state.branches,
  );
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);

  const clinicId = clinicInfo?.[0]?.clinicId;
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  useEffect(() => {
    if (clinicId) {
      dispatch(getParentData({ clinicId, token }));
    }
  }, [clinicId, dispatch, token]);

  useEffect(() => {
    if (branchSuccessMessage || branchErrorMessage) {
      showTostifyMessageAndReset(
        branchSuccessMessage,
        showToastifySuccess,
        resetBranchMessage,
      );
      showTostifyMessageAndReset(
        branchErrorMessage,
        showToastifyError,
        resetBranchMessage,
      );
    }
  }, [branchSuccessMessage, branchErrorMessage, showTostifyMessageAndReset]);

  const handleBranchAction = async (branch, branchRequest) => {
    if (clinicId && branch?._id) {
      const payload = {
        branchRequest,
        clinicId: branch?.parentClinicId?._id,
        branchId: branch?.branchClinicId?.[0]?.clinicId,
        token,
      };

      try {
        const res = await dispatch(handleBranchRequestSlice(payload));

        if (res?.meta?.requestStatus === "fulfilled") {
          dispatch(getParentData({ clinicId, token }));
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const navigate = useNavigate();
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Request Branch</h4>

        <button
          className="btn btn-secondary"
          onClick={() => navigate("/branch")}
        >
          ← Back to Branch
        </button>
      </div>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sl No</th>
              <th>Branch Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.list?.length > 0 ? (
              data.list.map((branch, index) => (
                <tr key={branch._id}>
                  <td>{index + 1}</td>
                  <td>{branch?.parentClinicId?.clinicName || "N/A"}</td>
                  <td>
                    {branch?.branchClinicId[0]?.branchRequest !==
                      "Accepted" && (
                      <>
                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={() => handleBranchAction(branch, "Accepted")}
                        >
                          ✓
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleBranchAction(branch, "Rejected")}
                        >
                          ✗
                        </button>
                      </>
                    )}
                    {branch?.branchClinicId[0]?.branchRequest ===
                      "Accepted" && (
                      <span className="text-muted">Accepted</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  No branches available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RequestBranch;
